import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import classNames from 'classnames';

import Type from '@nerdwallet/react-typography';
import WpEmbed from '@nerdwallet/react-wp-embed';
import nds from '@nerdwallet/base-styles/classes';
import appConfig from '@nerdwallet/app-config';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import { isInBuilder } from '../../lib/helpers';

import Row from '../row/row';

import { stringInputSpec } from '../../lib/editing-configs';

const Calculator = ({ cffId, history }) => {
  const iframeUrl = `${appConfig.SITE_BASE_URL}/blog/cff/?form_id=${cffId}`;

  const defaultEditorOutput = () => {
    const url = get(history, 'location.pathname');
    if (isInBuilder(url)) {
      return (
        <Row
          centeredInParent
          standardMaxWidths
          className={classNames(['calculator__default-output'])}
        >
          <Type
            size={3}
            bold
            className={nds('text-align-center', 'padding-vertical-5')}
          >
            Enter a CFF ID to make a calculator appear
          </Type>
        </Row>
      );
    }
    return null;
  };

  return !cffId ? (
    defaultEditorOutput()
  ) : (
    <Row
      centeredInParent
      standardMaxWidths
      className={nds('padding-vertical-3')}
    >
      <WpEmbed src={iframeUrl} />
    </Row>
  );
};

Calculator.propTypes = {
  cffId: PropTypes.string,
  history: PropTypes.object,
};

Calculator.getEditingConfig = () => [
  stringInputSpec('cffId', 'Calculated Fields Form ID', {
    help:
      'For a list of CFFs you can display on landing pages, login to Wordpress and navigate to Settings > Calculated Fields Form.',
  }),
];

export default compose(withRouter, connect())(Calculator);
